import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { Box, Typography } from "@mui/material";

const TOOLBAR = [
  [{ header: [2, 3, false] }],
  ["bold", "italic", "underline", "strike"],
  [{ list: "ordered" }, { list: "bullet" }],
  ["blockquote"],
  ["link"],
  ["clean"],
];

const FORMATS = [
  "header", "bold", "italic", "underline", "strike",
  "list", "bullet", "blockquote", "link",
];

const editorWrapperSx = {
  "& .ql-toolbar": {
    borderRadius: "4px 4px 0 0",
    backgroundColor: "#f5f5f5",
  },
  "& .ql-container": {
    borderRadius: "0 0 4px 4px",
    minHeight: "150px",
    fontSize: "14px",
  },
  "& .ql-editor": {
    minHeight: "150px",
  },
};

const RichTextEditor = ({ label, value, onChange }) => {
  return (
    <Box sx={editorWrapperSx}>
      {label && (
        <Typography variant="caption" color="text.secondary" sx={{ mb: 0.5, display: "block" }}>
          {label}
        </Typography>
      )}
      <ReactQuill
        theme="snow"
        value={value || ""}
        onChange={onChange}
        modules={{ toolbar: TOOLBAR }}
        formats={FORMATS}
      />
    </Box>
  );
};

export default RichTextEditor;
